import React from "react";

import Card from "components/card/Card";
import Divider from "components/divider";
import Page from "components/page/Page";
import { SkeletonBar } from "components/skeleton";

interface IInvoicePageSkeletonProps {
  itemsTitle: string;
  sidebarTitle: string;
  customerTitle?: string;
  editable?: boolean;
}

function InvoiceLineItemSkeleton({ editable }: { editable: boolean }) {
  return (
    <Card.SubSection>
      <div className={`invoice-line-item-skeleton${editable ? " invoice-line-item-skeleton--editable" : ""}`}>
        <div className="invoice-line-item-skeleton__product">
          <SkeletonBar width="11rem" height="1rem" />
          <SkeletonBar width="7rem" height="0.75rem" />
        </div>
        {editable ? (
          <div className="invoice-line-item-skeleton__inputs">
            <SkeletonBar height="2.5rem" />
            <SkeletonBar height="2.5rem" />
            <SkeletonBar height="2.5rem" />
            <SkeletonBar width="5rem" height="1rem" />
            <SkeletonBar width="1rem" height="1.5rem" />
          </div>
        ) : (
          <>
            <SkeletonBar width="7rem" height="1rem" />
            <SkeletonBar width="5rem" height="1rem" />
          </>
        )}
      </div>
    </Card.SubSection>
  );
}

export default function InvoicePageSkeleton({
  itemsTitle,
  sidebarTitle,
  customerTitle,
  editable = false,
}: IInvoicePageSkeletonProps) {
  return (
    <>
      <Page.Section twoThirds>
        {customerTitle && (
          <Card title={customerTitle}>
            <Divider className="mt-4! mb-4!" />
            <Card.Section>
              <div className="invoice-customer-skeleton">
                {[0, 1, 2].map(column => (
                  <div className="invoice-customer-skeleton__column" key={column}>
                    <SkeletonBar width={column === 0 ? "9rem" : "7rem"} height="1rem" />
                    <SkeletonBar width="11rem" height="0.75rem" />
                    <SkeletonBar width="8rem" height="0.75rem" />
                  </div>
                ))}
              </div>
            </Card.Section>
          </Card>
        )}

        <Card title={itemsTitle}>
          {editable && <Divider className="mt-4! mb-4!" />}
          <Card.Section>
            {[0, 1, 2, 3].map(row => (
              <InvoiceLineItemSkeleton editable={editable} key={row} />
            ))}
          </Card.Section>
          {!editable && (
            <Card.Section>
              <div className="invoice-total-skeleton">
                {[0, 1, 2].map(row => (
                  <div className="invoice-total-skeleton__row" key={row}>
                    <SkeletonBar width="6rem" height="0.75rem" />
                    <SkeletonBar width="5rem" height="0.75rem" />
                  </div>
                ))}
              </div>
            </Card.Section>
          )}
        </Card>
      </Page.Section>

      <Page.Section oneThird>
        <Card title={sidebarTitle}>
          {editable && <Divider className="mt-4! mb-4!" />}
          <Card.Section>
            <div className="invoice-details-skeleton">
              {[0, 1, 2, 3].map(row => (
                <div key={row}>
                  <SkeletonBar width="6rem" height="0.75rem" />
                  <SkeletonBar height={editable ? "2.5rem" : "1rem"} />
                </div>
              ))}
            </div>
          </Card.Section>
        </Card>
      </Page.Section>
    </>
  );
}
